<template>
    <div>
        <Info class="hover:text-indigo-500 cursor-pointer" @click="showModal = true"/>

        <Modal :title="title" :show="showModal" @close="showModal = false">
            <slot/>
        </Modal>
    </div>
</template>

<script>
import Info from '@/Components/Svg/Info.vue';
import Modal from '@/Components/Modal.vue';

export default {
    components: { Modal, Info },
    props: {
        title: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            showModal: false,
        }
    }
};
</script>
